<template>
  <div id="menuManage">
    <div class="rightCon contentPadding42" id="ManageTable">
      <div class="headTitle">
        <img src="@/assets/imgs/icon/icon_headIcon.png" alt />
        增加值率
      </div>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="期号" style="margin-right: 30px">
          <el-date-picker
            v-model="searchObj.ym"
            type="month"
            :clearable="false"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="行业代码" style="margin-right: 30px">
          <el-input
            v-model="searchObj.code"
            placeholder="请输入代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="行业名称" style="margin-right: 30px">
          <el-input
            v-model="searchObj.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSearch"
            class="bg5584FF formBotton"
            style="margin-left: 40px"
            >查询</el-button
          >
          <el-button type="info" @click="onReset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <hr />
      <div style="height: 20px"></div>
      <el-table
        v-loading="loading"
        :data="menuList"
        style="width: 100%"
        border
        stripe
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      >
        <el-table-column align="center" prop="code" label="行业代码">
        </el-table-column>
        <el-table-column align="center" prop="name" label="行业名称">
        </el-table-column>
        <el-table-column align="center" prop="ym" label="期号">
        </el-table-column>
        <el-table-column align="center" prop="ratio" label="增加值率(%)">
          <template slot-scope="scope">
            <div v-if="scope.row.edit">
              <el-input
                type="number"
                style="width: 70%"
                @blur="sureEdit(scope.row)"
                @keyup.enter.native="sureEdit(scope.row)"
                :ref="scope.row.id"
                v-model="scope.row.ratio"
              ></el-input
              ><i
                style="
                  float: right;
                  padding-right: 16px;
                  color: blue;
                  margin: autoba;
                "
                class="el-icon-edit"
              ></i>
            </div>
            <div v-else>
              <span>{{ scope.row.ratio }}</span
              ><i
                style="float: right; padding-right: 16px"
                @click="toInput(scope.row)"
                class="el-icon-edit"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="[20, 30, 50, 100]"
          layout="sizes, prev, pager, next, jumper"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      searchObj: {
        name: "",
        code: "",
        ym: this.$moment(new Date()).format("YYYY-MM"),
      },
      menuList: [],
      selectsuperMenu: [],
      currentPage: 1,
      pageSize: 20,
      loading: false,
      showEditWindow: false,
      totalNum: 0,
      pageObj: {},
      changeData: "",
    };
  },
  methods: {
    onSearch() {
      this.getMenuList();
    },
    onReset() {
      this.searchObj = {
        name: "",
        code: "",
        ym: this.$moment(new Date()).format("YYYY-MM"),
      };
      this.getMenuList();
    },
    sureEdit(row) {
      if (this.changeData === row.ratio || row["edit"] == false) {
        row["edit"] = false;
      } else {
        if (row.ratio) {
          this.$axios
            .put("/business/dm/zjz/update", {
              ratio: row.ratio,
              id: row.id,
            })
            .then((res) => {
              row["edit"] = false;
              Message.success("修改成功");
              console.log("编辑成功", res);
            })
            .catch((res) => {
              console.log("编辑错误", res);
            });
        } else {
          Message.error("请输入数字");
        }
      }
    },
    toInput(row) {
      row["edit"] = true;
      this.changeData = row.ratio;
      this.$nextTick(() => {
        this.$refs[`${row.id}`].focus();
      });
    },
    getMenuList(page) {
      this.loading = true;
      this.searchObj.ym = this.$moment(this.searchObj.ym).format("YYYY-MM");
      const param = Object.assign(
        {
          page: page ? page : 1,
          size: this.pageSize,
        },
        this.searchObj
      );
      this.$axios
        .post("/business/dm/zjz/page", param)
        .then((res) => {
          this.loading = false;
          this.menuList = [];
          res.data.forEach((temp) => {
            this.menuList.push(
              Object.assign(temp, {
                edit: false,
              })
            );
          });
          this.totalNum = res.total;
          console.log("行业列表结果", res);
        })
        .catch((res) => {
          this.loading = false;
          console.log("行业列表错误信息", res);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMenuList(1);
    },
    handleCurrentChange(current) {
      this.getMenuList(current);
    },
  },
  created() {
    this.getMenuList();
  },
};
</script>

<style lang="less" scoped>
#menuManage {
  min-height: calc(100vh - 76px);
  display: flex;
  .leftTree {
    width: 260px;
    background-color: rgba(247, 248, 250, 1);
    box-sizing: border-box;
    padding: 50px 0px 0px 20px;
  }
  .rightCon {
    width: 100%;
  }
}
#menuManage /deep/ .el-tree-node__children {
  .el-tree-node__label {
    padding: 2px 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }
  .el-tree-node:focus > .el-tree-node__content {
    background: rgba(247, 248, 250, 1);
    .el-tree-node__label {
      background-color: #5584ff;
      color: #fff;
      box-shadow: 0px 2px 4px 0px #5584ff;
    }
  }
  .el-tree-node.is-current {
    background: rgba(247, 248, 250, 1);
    .el-tree-node__label {
      background-color: #5584ff;
      color: #fff;
      box-shadow: 0px 2px 4px 0px #5584ff;
    }
  }
}
#menuManage .el-tree {
  background: rgba(247, 248, 250, 1);
}
.headTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(68, 68, 68, 1);
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  img {
    margin-right: 24px;
    padding-left: 2px;
  }
}
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 10px 0 20px;
}
</style>